import { defineFcm } from '../shared/factory';

export const FCM_SUNRISE_NAV_ENABLED = defineFcm('sunrise_nav_enabled').asBoolean().withDefault(false).toConfig();
